import { render, staticRenderFns } from "./SpecialSalesCarousel.vue?vue&type=template&id=28984f04&scoped=true&"
import script from "./SpecialSalesCarousel.vue?vue&type=script&lang=js&"
export * from "./SpecialSalesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./SpecialSalesCarousel.vue?vue&type=style&index=0&id=28984f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28984f04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VAvatar,VBtn,VCarousel,VCarouselItem,VDivider,VFlex,VIcon,VImg,VLayout,VProgressCircular,VSheet})
